import { useEffect, useState } from "react";
import axios from "axios";

const Breadcrumb = ({ currentFolderId, onNavigate, activeTab, selectedUser, setSelectedUser }) => {
  const [folderPath, setFolderPath] = useState([]);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const accessToken = sessionStorage.getItem("accessToken");
  const headers = accessToken ? { Authorization: accessToken } : {};

  useEffect(() => {
    if (activeTab === "User Files" && selectedUser) {
      if (currentFolderId) {
        fetchBreadcrumbPath(currentFolderId, selectedUser);
      } else {
        setFolderPath([
          { id: null, name: "Root" },
          { id: `user-${selectedUser}`, name: `${selectedUser}_workspace` },
        ]);
      }
    } else {
      if (currentFolderId !== null) {
        fetchBreadcrumbPath(currentFolderId);
      } else {
        setFolderPath([{ id: null, name: "Root" }]);
      }
    }
  }, [currentFolderId, activeTab, selectedUser]);

  const fetchBreadcrumbPath = async (folderId, user = null) => {
    try {
      const { data } = await axios.get(`${baseUrl}/storage/folder/${folderId}/path`, { headers });

      if (user) {
        setFolderPath([
          { id: null, name: "Root" },
          { id: `user-${user}`, name: `${user}_workspace` },
          ...data,
        ]);
      } else {
        setFolderPath([{ id: null, name: "Root" }, ...data]);
      }
    } catch (err) {
      console.error("Failed to fetch breadcrumb path:", err);
    }
  };

  const handleClick = (folder) => {
    if (folder.id === null) {
      setSelectedUser(null);
      onNavigate(null);
    } else if (folder.id?.toString().startsWith("user-")) {
      setSelectedUser(folder.name.replace("_workspace", ""));
      onNavigate(null); 
    } else {
      onNavigate(folder.id);
    }
  };
  

  return (
    <nav className="breadcrumb-container px-3 mb-3">
      {folderPath.map((folder, index) => (
        <span key={folder.id || "root"}>
          <span
            className={`breadcrumb-item fnt14 fw-500 ${index !== folderPath.length - 1 ? "breadcrumb-text-decoration" : ""}`}
            onClick={() => handleClick(folder)}
            style={{
              cursor: "pointer",
              color: index === folderPath.length - 1 ? "#25a9e0" : "",
            }}
          >
            {folder.name}
          </span>
          {index < folderPath.length - 1 && <span className="mx-1">/</span>}
        </span>
      ))}
    </nav>
  );
};

export default Breadcrumb;
